
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { Activity, TrendingUp } from "lucide-react";

const NavigationCards: React.FC = () => {
  return (
    <div className="grid grid-cols-1 gap-4">
      <Link to="/analytics" className="no-underline">
        <Card>
          <CardContent className="p-4">
            <div className="flex items-center">
              <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center mr-3">
                <Activity className="h-5 w-5 text-primary" />
              </div>
              <div>
                <h3 className="font-medium">Analytics</h3>
                <p className="text-sm text-muted-foreground">View insights</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </Link>

      <Link to="/calculator" className="no-underline">
        <Card>
          <CardContent className="p-4">
            <div className="flex items-center">
              <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center mr-3">
                <TrendingUp className="h-5 w-5 text-blue-500" />
              </div>
              <div>
                <h3 className="font-medium">Calculator</h3>
                <p className="text-sm text-muted-foreground">View estimates</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </Link>
    </div>
  );
};

export default NavigationCards;
